import React from 'react';
import type { TurnaroundPair } from '../../../../api/stays-alerts-client';
import type { StayFull } from '../../../../interfaces/stays';
import { StatusPill } from '../../../status-pill/status-pill';
import { BodyRow, Td } from '../../../table/list-table';
import { formatDayKey } from '../../../../function-utils/building-time';
import { windowPillLabel } from '../../../../utils/stays-turnaround';
import { shortName } from '../reservations/reservation-labels';
import { Bridge, Strong, Times } from './operations.styled';

/**
 * THE SAME-DAY TURNAROUND BRIDGE, S8's version (SC-2; K-65, R-S8.17). Drawn
 * instead of S4's TurnaroundRow when operations-today carries the pair: the
 * window in real minutes (a DST night counted right), "Arrival is before
 * checkout" for an overlap (never Konios's +24 hours), urgent at two hours or
 * less, and whether the departing stay's cleaning is booked. Times are BUILDING
 * wall-clock (data-time); the table states the building clock once.
 */

export const TurnaroundBridge: React.FC<{
  pair: TurnaroundPair;
  departing: StayFull;
  arriving: StayFull;
  columns: number;
  index: number;
}> = ({ pair, departing, arriving, columns, index }) => (
  <BodyRow index={index} data-turnaround={pair.date} data-out={departing.id} data-in={arriving.id}
    data-window={pair.window_minutes} data-overlap={pair.overlap || undefined}>
    <Td colSpan={columns} data-label="Turnaround">
      <Bridge>
        <Strong>Same-day turnaround · {formatDayKey(pair.date, { weekday: 'short', day: 'numeric', month: 'short' })}</Strong>
        <Times>
          {shortName(departing)} leaves at <span data-time={pair.out_time}>{pair.out_time}</span>, {shortName(arriving)} arrives at{' '}
          <span data-time={pair.in_time}>{pair.in_time}</span>
        </Times>
        <StatusPill tone={pair.urgent ? 'alert' : 'neutral'} dot>
          {windowPillLabel(pair)}
        </StatusPill>
        <StatusPill tone={pair.cleaning_booked ? 'success' : 'warning'} dot>
          {pair.cleaning_booked ? 'Cleaning booked' : 'Rapid cleaning needed'}
        </StatusPill>
      </Bridge>
    </Td>
  </BodyRow>
);
